enum ProductComplianceTechnicalHeadingTypeEnum {
	energyEfficiencyClass = 'ENERGY_EFFICIENCY_CLASS',
	rescaled = 'PRODUCT_INFO_SHEET',
	nonRescaled = 'PRODUCT_FICHE',
	hyperlink = 'HYPERLINK',
	unifiedWaterLabel = 'GRAPHICAL_ELEMENT',
	repairabilityIndex = 'REPAIRABILITY_INDEX',
	doNotDiy = 'INSTALLATION_TYPE'
}

export default ProductComplianceTechnicalHeadingTypeEnum;
